<template>
  <div>
    <GameBoard v-if="room.myRoom" />
  </div>
</template>
<script>
import store from "@/store";
import server from "@/server";
import GameBoard from "@/components/GameBoard";
export default {
  computed: {
    room: () => store.state.room,
    isDirectRoomLoad: () => store.getters.isDirectRoomLoad
  },
  components: {
    GameBoard
  },
  mounted: function() {
    if (this.isDirectRoomLoad) {
      const roomId = this.$route.params.roomId;
      if (this.$route.params.playerId) {
        const playerId = this.$route.params.playerId;
        server.reJoin(roomId, playerId, false);
      } else {
        server.joinBingoRoom(roomId, false);
      }
    }
  }
};
</script>
